<template>
    <div class="content-wrapper" v-if="invoice.InvoiceNumber">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.show') +' '+ invoice.InvoiceNumber"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <back-button :storeLocal="true"></back-button>

                <div class="d-inline-block float-right">
                    <button class="btn btn-danger" @click="generate('pdf')">
                        <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.pdf')}}
                    </button>
                    <button class="btn btn-primary" @click="generate('word')">
                        <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.word')}}
                    </button>
                </div>

                <hr>

                <div class="row">
                    <div class="col-md-10 mx-auto">
                        <div class="card" style="padding: 100px 40px; font-size: 95%; width: 720px;margin: 0 auto;">

                            <div class="card-body">
                                <div class="row offset-md-8  col-4">
                                    <p class="mb-0 w-100" v-if="invoice.MailAddress==1">{{student.Title}} {{student.FirstName}} {{student.LastName}}</p>
                                    <p class="mb-0 w-100" v-if="invoice.MailAddress!==1">{{student.StudentBusiness.CompanyName}}</p>
                                    <p class="mb-0 w-100" v-if="invoice.MailAddress==1">{{student.StreetAddress}}</p>
                                    <p class="mb-0 w-100" v-if="invoice.MailAddress==1">{{student.Zip}} {{student.City}}</p>
                                    <p class="mb-0 w-100" v-if="invoice.MailAddress==1">{{student.Country}}</p>

                                    <p class="mb-0 w-100" v-if="invoice.MailAddress!==1">{{student.StudentBusiness.StreetAddress}}</p>
                                    <p class="mb-0 w-100" v-if="invoice.MailAddress!==1">{{student.StudentBusiness.Zip}} {{student.StudentBusiness.City}}</p>
                                    <p class="mb-0 w-100" v-if="invoice.MailAddress!==1">{{student.StudentBusiness.Country}}</p>

                                    <p class="mb-0 w-100" v-if="invoice.InvoiceInfo">{{invoice.InvoiceInfo}}</p>

                                    <p class="mt-5 w-100">
                                    {{$t('form.invoice.zurich')}} {{invoice.InvoiceDate | formatDate(dateFormat)}}
                                    </p>
                                </div>

                                <!-- <div class="clearfix"></div> -->

                                <div>
                                    <p><strong>{{$t('form.invoice.invoiceNo')}} {{invoice.InvoiceNumber}}</strong></p>
                                </div>
                                <div >
                                    <p>{{$t('form.invoice.dear')}} {{student.Title}} {{student.LastName}},
                                    </p>
                                    <p>{{$t('form.invoice.makePaymentText')}}</p>
                                    <div>
                                        <p class="font-weight-bold d-inline">
                                        <template>
                                        <table class='table table-sm my-4'>
                                          <tr class="d-flex">
                                            <td class="text-left col-10"><span style="font-weight:bolder">{{invoice.InvoicePurpose}}
                                                <span v-if="invoice.Discount > 0 && invoice.DiscountedAmount != invoice.Amount && invoice.Zero == false && (invoice.InvoicedSeparately == 0)">{{$t('form.invoice.with_grant')}}</span><span v-else-if="invoice.Discount > 0 && invoice.InvoiceFullPaymentDiscount > 0 && invoice.Zero == false && invoice.InvoicedSeparately > 0 && invoice.PaymentPlan === 'Full Payment'">{{$t('form.invoice.with_grant')}}</span>:</span>
                                            </td>
                                            <td v-if="invoice.Zero == true" class="text-right col-2"><span>{{invoice.Currency}} 0.00</span></td>
                                            <td v-else-if="!invoice.Discount && invoice.IsSeparately == 0" class="text-right col-2"><span>{{invoice.Currency}} {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            <td v-if="invoice.Zero == false && invoice.Discount > 0 && invoice.PaymentPlan=='by Course/Semester/Term' && invoice.InvoicedSeparately == 0" class="text-right col-2"><span>{{invoice.Currency}} {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            <td v-else-if="invoice.Zero == false && invoice.Discount > 0 && invoice.InvoicedSeparately > 0 && invoice.PaymentPlan != 'Full Payment'" class="text-right col-2"><span>{{invoice.Currency}} {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            <td v-else-if="invoice.IsSeparately == 1 && invoice.PaymentPlan == 'Full Payment'" class="text-right col-2"><span>{{invoice.Currency}} {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            <td v-if="invoice.Discount > 0 && invoice.CreatedBy == 'Manual'" class="text-right col-2"><span>{{invoice.Currency}} {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            <td v-if="invoice.Zero == false && invoice.Discount > 0 && invoice.PaymentPlan === 'Full Payment' && invoice.IsSeparately == 0" class="text-right col-2"><span>{{invoice.Currency}} {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                            <!-- <td v-else class="text-right col-2"><span>{{invoice.Currency}} {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td> -->
                                            <td class="w-10"></td>
                                          </tr>
                                          <tr class="d-flex" v-if="(invoice.Zero == false && invoice.Discount > 0 && invoice.DiscountedAmount != invoice.Amount && invoice.InvoicedSeparately == 0) || (invoice.PaymentPlan=='by Course/Semester/Term' && invoice.DeductibleCourses.length != 0 && invoice.Zero == false && invoice.InvoicedSeparately == 0)" >
                                                <td class="text-left col-12">{{invoice.Note}}</td>
                                           </tr>
                                           <tr class="d-flex" v-if="invoice.Zero == false && invoice.DeductibleCourses.length != 0 && (invoice.PaymentPlan !='by Course/Semester/Term' && invoice.Discount < 0)" v-for="(course, index) in invoice.DeductibleCourses" v-bind:key="index">
                                                <td class="text-left col-10"><span>-{{$t('form.invoice.less_deductible',{
                                                CourseCode:course.CourseCode,
                                                CourseTitle:course.CourseTitle
                                                })}}</span></td>

                                                <td class="text-right col-2"><span>{{invoice.Currency}} {{course.fee | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                           </tr>
                                           <tr class="d-flex" v-if="invoice.Zero == false && invoice.DeductibleCourses.length != 0 && invoice.PaymentPlan =='by Course/Semester/Term' && invoice.Discount == 0" v-for="(course, index) in invoice.DeductibleCourses" v-bind:key="index">
                                                <td class="text-left col-10"><span>-{{$t('form.invoice.less_deductible',{
                                                CourseCode:course.CourseCode,
                                                CourseTitle:course.CourseTitle
                                                })}}</span></td>

                                                <td class="text-right col-2"><span>{{invoice.Currency}} {{course.fee | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                           </tr>
                                           <tr v-if="invoice.PaymentPlan === 'Full Payment' && invoice.acceptanceFee === 0 && invoice.IsSeparately == 0" class="d-flex">
                                                <td class="text-left col-10"><span class=" font-weight-bold ">-{{$t('form.invoice.less_full_payment_discount')}} ({{student.FullPaymentDiscount}}% ):</span></td>
                                                <td class="text-right col-2"><span>{{invoice.Currency}} {{ invoice.InvoiceFullPaymentDiscount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                              
                                              
                                                <td class="w-10"></td>
                                           </tr>
                                        
                                             <tr v-if="invoice.Zero == false &&invoice.AdministrationFee > 0 && invoice.PaymentPlan === 'Full Payment'" class="d-flex">
                                                <td class="text-left col-10"><span class=" font-weight-bold ">-{{$t('form.invoice.less_administration_fee')}}:</span></td>
                                                <td class="text-right col-2"><span>{{invoice.Currency}} {{ invoice.AdministrationFee | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                <td class="w-10"></td>
                                           </tr>
                                           <tr  v-if="invoice.Zero == false && invoice.PaymentPlan === 'Full Payment' && invoice.IsSeparately == 0"  class="d-flex" v-for="(courseIS, index) in invoice.InvoicedSeparatelyCourses" v-bind:key="index">
                                            <td v-if="invoice.Zero == false && invoice.PaymentPlan === 'Full Payment' && invoice.InvoicedSeparately != 0"  class="text-left col-10">  -less {{ courseIS.CourseCode}} {{ courseIS.CourseTitle}} (invoiced separately):</td>
                                            <td v-if="invoice.Zero == false && invoice.PaymentPlan === 'Full Payment' && invoice.InvoicedSeparately != 0"  class="text-right col-2"><span>{{invoice.Currency}} {{ courseIS.Fee  | formatCurrencyDouble}}</span></td>
                                          </tr>
                                          <tr  v-if="invoice.zero == false && (invoice.DeductibleCourses.length>0 || invoice.InvoicedSeparatelyCourses.length>0) && (invoice.Discount > 0 || invoice.InvoiceFullPaymentDiscount > 0) && (invoice.DiscountedAmount > 0 ? invoice.DiscountedAmount: invoice.Amount) && invoice.student.length != 0"  class="d-flex">
                                                <td class="text-left font-weight-bold  col-9"></td>
                                                <td class="text-right col-3"><span class="font-weight-bold" style="text-decoration: overline 2px black">{{$t('form.invoice.total')}}: {{invoice.Currency}} {{invoice.Total | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                <td class="w-10"></td>
                                           </tr>
                                           <tr  v-if="(invoice.PaymentPlan=='by Course/Semester/Term' && invoice.DeductibleCourses.length != 0) || (invoice.PaymentPlan=='Full Payment' && invoice.DeductibleCourses.length != 0) && (invoice.DiscountedAmount > 0 ? invoice.DiscountedAmount: invoice.Amount)"  class="d-flex">
                                                <td class="text-left font-weight-bold  col-9"></td>
                                                <td v-if="invoice.Zero == false && invoice.DiscountedAmount == 0" class="text-right col-3"><span class="font-weight-bold" style="text-decoration: overline 2px black">{{$t('form.invoice.total')}}: {{invoice.Currency}} {{invoice.Total | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                <td class="w-10"></td>
                                           </tr>
                                           <tr  v-if="(invoice.PaymentPlan ==='Full Payment' && invoice.DiscountedAmount > 0 && invoice.InvoiceFullPaymentDiscount > 0) || (invoice.PaymentPlan ==='Full Payment' && invoice.InvoiceFullPaymentDiscount > 0)"  class="d-flex">
                                                <td class="text-left font-weight-bold  col-9"></td>
                                                <td class="text-right col-3"><span class="font-weight-bold" style="text-decoration: overline 2px black">{{$t('form.invoice.total')}}: {{invoice.Currency}} {{invoice.Total | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</span></td>
                                                <td class="w-10"></td>
                                           </tr>
                                         </table>
                                        </template>
                                        </p>
                                    </div>


                                    <p class="mt-3 mb-0">{{$t('form.invoice.bankDetails')}}</p>
                                    <div class="pt-3">
                                        <p class="mb-0">{{bank.beneficiary}}</p>
                                        <p class="mb-0">{{bank.name}}</p>
                                        <p class="mb-0">{{bank.account_no}}</p>
                                        <p class="mb-0">{{bank.swift_code}}</p>
                                        <p class="mb-0">{{bank.clearing_no}}</p>
                                        <p class="mb-0">{{bank.iban}}</p>
                                    </div>
                                    <p class="mt-3">{{$t('form.invoice.exemptedFromVAT')}}</p>
                                </div>

                                <div class="mt-0">
                                    <p class="mb-0">{{$t('form.invoice.askForPaymentText')}} <span
                                            class="font-weight-bold">{{$t('form.invoice.by')}}
                                            {{invoice.DueDate | formatDate(dateFormat)}}</span>. </p>

                                            <p class="mt-3">
                                                <strong>{{$t('form.invoice.bankingFees')}}</strong>
                                            </p>
                                    <p class="mt-5">{{$t('form.invoice.thankForCollaboration')}}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="content-wrapper" v-else><h4>Invoice Not found</h4></div>
   
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat', 'decimalDigits', 'decimalPoint', 'thousandSeparator'],

        data() {
            return {
                isLoading: false,
                fullPage: true,
                student:{
                    Title: null,
                    FirstName: "",
                    LastName: "",
                    CompanyName: null,
                    StreetAddress: null,
                    City: null,
                    Zip: null,
                    Country: null,
                },
                invoice: {
                    Amount: null,
                    Currency: null,
                    DueDate: null,
                    ID: null,
                    InvoiceInfo: "",
                    InvoiceDate: null,
                    InvoiceNumber: null,
                    InvoicePurpose: null,
                    Paid: null,
                    PaymentDate: null,
                    TS: null,
                    Note:null
                },
                bank: {},
                availableFormats: ['pdf', 'word']
            }
        },

        async mounted() {
            if (!this.permissions.viewInvoices) {
                this.$router.push("/");
                return;
            }
            await this.getConfig();
            this.getInvoice();
        },

        methods: {
            async getConfig(){
                var self = this;
                try{
                    const response = await axios.get('/api/config');
                    if (response.data) {
                        let config = response.data;
                        self.free_courses = config.free_courses;
                    }
                }catch(error){
                    console.log('error in getting config values')
                }
            },
            getDateWithMonthInEnglish(date){
                var dateFormat = 'DD MMM YYYY';
                var formattedDate = date ? moment(date).format(dateFormat) : moment().format(dateFormat);
                return formattedDate;
            },
            getDateWithMonthAndYear(date){
                var dateFormat = 'MMM YYYY';
                var formattedDate = date ? moment(date).format(dateFormat) : moment().format(dateFormat);
                return formattedDate;
            },
            getBank() {
                this.isLoading = true;

                axios
                    .get(`/api/bank-details?currency=${this.invoice.Currency}`)
                    .then(response => {
                        this.isLoading = false;
                        this.bank = response.data
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error fetching bank details.');
                    });
            },

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {type,
                description: this.$t("form.setting.description")
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async generate(type = null) {
                if (!this.availableFormats.includes(type)) return;

                let token = await this.createToken('student-attachment');
                if (token == '') return;

                window.open(`/invoices/${this.$route.params.id}/${type}?token=${token}`, '_blank');
            },

            getInvoice() {
                this.isLoading = true;

                if (!this.$route.params.id) return;

                axios
                    .get(`/api/invoices/${this.$route.params.id}`)
                    .then(response => {
                        if(response.data)
                        this.isLoading = false;
                        this.invoice = response.data;
                        this.student = this.invoice.Student;
                        this.getBank();
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    });
            }
        },

    }

</script>
<style scoped>

.underlined {
    border-bottom: 5px double;
}

.w-20 {
  width: 20%;
}

.w-50 {
  width: 50%;
}


.w-10 {
  width: 10%;
}

table {
  table-layout:fixed;/* will switch the table-layout algorythm */
}
table td{
    border-top : none !important;
}
.borderless td, .borderless th {
    border: none;
}
tr td {
    padding-top: 0em;
}
u {
  padding-bottom:3px;
  text-decoration:none;
  border-bottom:2px solid #4a4e51;
}
</style>
